import React from "react";
import { CodeIcon } from "@heroicons/react/solid";
import { projects } from "../data";

const Projects = () => {
  return (
    <section id="projects" className="text-gray-400 bg-gray-900 body-font">
      <div className="container px-5 py-5 mx-auto text-center lg:px-40">
        <div className="flex flex-col w-full mb-20 items-center">
          <CodeIcon className="mx-auto inline-block w-10 mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
            Projects I have built
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
            Most of them are shared through my Youtube Channel
          </p>
          <a
            href="https://www.youtube.com/@carlos_zapata"
            target="_blank"
            rel="noopener noreferrer"
            class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full m-5"
          >
            YouTube Channel @carlos_zapata
          </a>
        </div>
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {projects.map((project) => (
            <div className="flex relative">
              <iframe
                className="px-4 py-4 z-10 w-full border-4 border-gray-800 bg-gray-900 opacity-100 hover:opacity-80"
                width="560"
                height="315"
                src={project.link}
                title="Video Player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;



// WEBPACK FOOTER //
// ./src/components/Projects.js